import Misc from './misc';

class SingleProductAuctions {
  constructor() {
    this.bidForm = document.querySelector('#yith-wcact-form-bid');
    this.bidAmount = document.querySelector('span.woocommerce-Price-amount');
    this.bidAmountOnAutoUpdate = this.bidAmountOnAutoUpdate.bind(this);

    if (this.bidForm) {
      this.checkUserBidPermission();
      this.checkSuccessfulBidMessage();

      // this.bidAmount.addEventListener('DOMSubtreeModified', this.bidAmountOnAutoUpdate );
    }
  }

  checkUserBidPermission() {

    if (site.hasOwnProperty('can_current_user_bid_auction') && !site.can_current_user_bid_auction) {
      
      this.bidForm.querySelector('button[type="button"]').setAttribute('disabled', true);
      this.bidForm.addEventListener('submit', event => {
        event.preventDefault();
      });

      let message = document.createElement('p');
      message.classList.add('pt1');
      message.classList.add('woocommerce-notices-wrapper');
      message.innerHTML = '<div class="woocommerce-error" role="alert">Your account is under verification. You cannot bid at this stage.</div>';
      
      Misc.insertAfter(this.bidForm, message);

      document.querySelector('#yith_wcact_manual_bid_increment').style.display = 'none';

    }

    if (site.hasOwnProperty('minimum_increment_amount') && site.minimum_increment_amount && document.querySelector('#yith_wcact_manual_bid_increment p')) {
      let minimumAmount = document.createElement('span');
      minimumAmount.classList.add('minimum-amount-notice');
      minimumAmount.innerHTML = `Please note, the minimum bid increment is <strong>${site.minimum_increment_amount}</strong>`;
      Misc.insertAfter(document.querySelector('#yith_wcact_manual_bid_increment p'), minimumAmount);
    }

  }

  checkSuccessfulBidMessage() {
    
    const message = document.querySelector('.woocommerce-message');
    
    if (!message) {
      return false;
    }

    if (message.innerHTML.trim() === 'You have successfully bid') {
     setTimeout(function() {
      message.style.display = 'none';
     }, 5000);
    }

  }

  bidAmountOnAutoUpdate(event) {
    let updatedAmount = event.currentTarget.querySelector('bdi').textContent;
    let minimumAmountString = `This bid is on auto refresh, the current bid is <strong>${updatedAmount}</strong>`
    
    let minimumAmount = document.createElement('span');
    minimumAmount.classList.add('minimum-amount-notice-updated');
    minimumAmount.innerHTML = minimumAmountString;
    
    if (!document.querySelector('.minimum-amount-notice-updated')) {
      Misc.insertAfter(document.querySelector('#yith-wcact-form-bid'), minimumAmount);
    } else {
      document.querySelector('.minimum-amount-notice-updated').innerHTML = minimumAmountString;
    }
  }


}

new SingleProductAuctions();
